import { GALoggerService } from 'src/app/share/service/galogger.service';
import { MemberProxyService } from 'src/app/member/service/member-proxy.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, AfterViewInit, OnDestroy, ViewChild, Optional, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { PhotoSwipeComponent, PhotoSwipeFigureSlide, PhotoSwipeFigureSlideDownLoadData, PhotoSwipeService } from '@techmore/photo-swipe';
import { Observable, Subscription, combineLatest, Subject } from 'rxjs';
import { map, startWith, switchMap, take, filter } from 'rxjs/operators';
import { DataSearchService } from 'src/app/data-search/data-search.service';
import { ITRISearchResult, ITRISearchResultRecord } from 'src/app/data-search/entity/search-result';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { SwiperDirective } from 'src/app/swiper/swiper.directive';
import { isSupportObjectFit, loadLazyCssFile, navigateCrossPlatform, randomData, removeUrlQueryParam } from 'src/app/util';
import { Authority } from 'src/app/web-generator/cms-generator/entity/authority';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { SwiperOptions } from 'swiper';
import { COMMON_FIELD_KEYS, Detail } from '../../detail';
import { DownloadTooltipComponent } from '../download-tooltip/download-tooltip.component';
import { Request } from 'express';
import { TranslateService } from '@ngx-translate/core';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { transformAuthLicense } from 'src/app/share/directive/auth-license.directive';
import { UserService } from 'src/app/share/service/user.service';
import { LoggerService } from 'src/app/share/service/logger.service';
import { isNullOrUndefined } from 'util';
import { Response } from 'express';
import { GlobalComponentService } from '@techmore/global';
import { MEMBER_LOGIN_WAY } from '../../../member/entity/member-login-way';
// import { detailTestData } from '../../detail_test_data';

/** 素材detail頁面 */
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: [
    '../../../web-generator/index-section-generator/module/index-subject/index-subject-04/index/index.component.scss',
    './cms-search-01.scss',
    './cms-search-01-share-tool.scss',
    './detail.component.scss',
  ]
})
export class DetailComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('imageSwiper', {static: false}) imageSwiperRef: SwiperDirective;
  @ViewChild('openReuseGallery', {static: false}) openReuseGallery: ElementRef;
  @ViewChild('dwTooltip', {static: false}) dwTooltip: DownloadTooltipComponent;
  @ViewChild(PhotoSwipeComponent, {static: false}) photoSwipeCmp: PhotoSwipeComponent;
  readonly apiHost = this.generatorEnv.apiHost;
  readonly isSupportObjectFit = isSupportObjectFit;
  /** 到首頁的路徑 */
  toHomePath: string;
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 頁面 data */
  data: Detail;
  /** 使用者留言是否正在上傳中 */
  isCommentUploading = false;
  /** 代表圖像用的swiper參數 */
  imgswiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
    }
  };
  /** 共通欄位名稱 */
  readonly COMMON_FIELD_KEYS = COMMON_FIELD_KEYS;
  /** 非共通欄位名稱 */
  nonCommonFieldKeys = [];
  private _subc: Subscription[] = [];
  /** 其它"查這筆資料用的關鍵字"的其它資料 */
  otherRadomDatas: ITRISearchResultRecord[];
  /** 從查詢頁進來所使用的查詢資料關鍵字 */
  usedKeyword: string;
  /** 來源機關的代號(網址上的) */
  fetchIndexCode: string;
  /** 素材編號(網址上的) */
  materialId: string;
  /** 留言 */
  messages: {
    name: string;
    message: string;
    createDate?: string;
    response?: string;
    modifyDate?: string;
  }[];
  /** 重新抓取留言紀錄的觸發器 */
  private refetchMessage$ = new Subject<void>();
  /** 可供下載圖片的(相片瀏覽器)資料 */
  openReuseGalleryImages: PhotoSwipeFigureSlide[] = [];
  /** 內文(下載視窗用的資料) */
  contentDownLoadData: PhotoSwipeFigureSlideDownLoadData;
  /** 當前的網址 */
  readonly sourceUrl: string;
  /** 當前頁面用來分享的網址 */
  sharePageUrl: string;
  /** json-ld 格式資料 */
  schemaOrgData: any;
  /** 會員資料 */
  memberInfo: any;
  readonly COLOR_STICKS = [
    '#00a1c7', '#c943b1', '#8a6a44', '#b6ad6a', '#785fd2',
    '#637251', '#93957f', '#6a443b', '#D97E40', '#D5BD19',
    '#1E63B5', '#51AD35'
  ];
  /** 是否顯示3D檔案 */
  isShow3DFiles = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    private serverConfigService: ServerConfigService,
    private commonHttp: CommonHttpClientService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private el: ElementRef,
    private dataSearchService: DataSearchService,
    private photoSwipeService: PhotoSwipeService,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected templateService: TemplateService,
    protected translateService: TranslateService,
    protected memberProxyService: MemberProxyService,
    protected userService: UserService,
    protected gALoggerService: GALoggerService,
    private zone: NgZone,
    private loggerService: LoggerService,
    @Optional() @Inject(RESPONSE) private response: Response,
    private render: Renderer2,
    private globalComponentService: GlobalComponentService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.toHomePath = `/${serverConfigService.config.lang}`;
    this.sourceUrl = serverConfigService.url;
    if (!this.isBrowser) {
      this.loggerService.info(`DetailComponent create`);
    }
  }

  ngOnInit() {
    let subc: Subscription;

    if (!this.isBrowser) {
      this.loggerService.info(`DetailComponent OnInit`);
    }
    if (this.isBrowser) {
      // 取更多"同個關鍵字"的查詢結果
      subc = combineLatest(
        this.dataSearchService.getParams(null),
        this.route.queryParams,
      ).pipe(
        map(([options, queryParams]) => {
          // 檢查所有查詢需要的參數都在網址上(才組成參數物件)，否則回傳空物件不打查詢列表api
          const requiredKeys = ['limit', 'offset', 'sort', 'order', 'isFuzzyMode', 'keyword', 'query'];
          let lostAny = false;
          for (let i = 0; i < requiredKeys.length && !lostAny; i++) {
            const key = requiredKeys[i];
            if (!(key in queryParams)) {
              lostAny = true;
            }
          }
          if (lostAny) { return null; }

          // 組查詢 api 用的參數
          const ret: any = {
            limit: 10,
            offset: ('recOffset' in queryParams) ? +queryParams['recOffset'] + 1 : 0,
            query: {},
          };
          if (queryParams['keyword']) {
            ret['keyword'] = queryParams['keyword'];
            this.usedKeyword = queryParams['keyword'];
          } else {
            return null;
          }
          ['sort', 'order', 'isFuzzyMode'].forEach(key => {
            if (!queryParams[key]) {
              console.error(`lack url query params [${key}]`);
              ret[key] = '';
            } else if (key === 'isFuzzyMode') {
              ret[key] = queryParams[key] === 'true';
            } else {
              ret[key] = queryParams[key];
            }
          });
          if (queryParams && queryParams['query']) {
            let queryObj: any;
            try {
              queryObj = JSON.parse(queryParams['query']);
            } catch (error) {}

            Object.assign(ret.query, queryObj);
            ['subject', 'format', 'city'].forEach(key => {
              if (queryObj[key]) {
                const f = options[key].find(opt => opt.label === queryObj[key]);
                ret.query[key] = f;

                if (key === 'city') {
                  if (queryObj['dist']) {
                    const distName = queryObj[key];
                    const f2 = ret.query['city'].data.dist.find(opt => opt.label === distName);
                    if (f2) {
                      ret.query['dist'] = f2.dist;
                    }
                  }
                }
              }
            });
            ['fetchIndex', 'rights', 'desRights'].forEach(key => {
              if (queryObj[key]) {
                const opts = queryObj[key].map(label => {
                  const f = options[key].find(opt => opt.label === label);
                  return f;
                });
                ret.query[key] = opts;
              }
            });
          }

          ret.query = JSON.stringify(ret.query);
          return ret;
        }),
        switchMap(params => {
          if (params) {
            return this.loadData(params);
          } else {
            return new Observable(observer => {
              observer.next(undefined);
            });
          }
        })
      ).subscribe((searchResult: ITRISearchResult) => {
        if (searchResult && searchResult.records && searchResult.records.length) {
          searchResult.records.forEach(rec => {
            // 他們的圖片有好幾個，解析後只取第一個就好
            if (rec['imageUrl']) {
              const messImgArr = rec['imageUrl'].split('@#@');
              rec['imageUrl'] = messImgArr[0] || messImgArr[1];
            }

            /** 影音應該讀取 iframeUrl, 但目前後端有些塞在 imageUrl, 在未來應該就不需要特別這段 */
            if (!rec['iframeUrl'] && rec.imageUrl && rec.imageUrl.includes('imedia')) {
              rec['iframeUrl'] = rec.imageUrl;
            }
          });

          this.otherRadomDatas = randomData(searchResult.records).slice(0, 4);
        }
      });
      this._subc.push(subc);

      // 紀錄使用者查詢關鍵字後點了某筆素材的行為
      subc = this.route.queryParams.pipe(
        take(1),
        map(params => ({fetchIndex: params.indexCode, materialId: params.id, keyword: params.keyword, searchWithKeywordTimeStamp: params.searchWithKeywordTimeStamp})),
        filter(params => params.keyword && params.searchWithKeywordTimeStamp && !0),
        switchMap(params => {
          const clone = JSON.parse(JSON.stringify(this.route.snapshot.queryParams));
          delete clone.searchWithKeywordTimeStamp;
          this.router.navigate([], { relativeTo: this.route, replaceUrl: true, queryParams: clone});
          return this.dataSearchService.logUser2DetailWithKeyword(params.fetchIndex, params.materialId, params.keyword, params.searchWithKeywordTimeStamp);
        }),
      ).subscribe({
        error: error => {
          console.error('log search action fail: ', error);
        }
      });
      this._subc.push(subc);
    }

    // 取素材明細
    if (!this.isBrowser) {
      this.loggerService.info(`DetailComponent 取素材明細`);
    }
    subc = this.route.queryParams.pipe(
      map(params => ({fetchIndex: params.indexCode, materialId: params.id})),
      switchMap(({fetchIndex, materialId}) => {
        this.fetchIndexCode = fetchIndex;
        this.materialId = materialId;
        if (this.isBrowser) {
          this.sharePageUrl = `${location.origin}${location.pathname}?indexCode=${fetchIndex}&id=${materialId}`;
          window.scrollTo(0, 0);
        }
        if (!this.isBrowser) {
          this.sharePageUrl = `${this.request.protocol}://${this.request.get('host')}${this.serverConfigService.pathname}?indexCode=${fetchIndex}&id=${materialId}`;
          this.loggerService.info(`DetailComponent 取素材明細 call API`);
        }
        this.render.setAttribute(this.document.head.querySelector('link[rel="canonical"]'), 'href', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()) + `?indexCode=${fetchIndex}&id=${materialId}`);
        this.render.setAttribute(this.document.head.querySelector('meta[property="og:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()) + `?indexCode=${fetchIndex}&id=${materialId}`);
        this.render.setAttribute(this.document.head.querySelector('meta[name="twitter:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()) + `?indexCode=${fetchIndex}&id=${materialId}`);
        return this.commonHttp.get<Detail>(`${this.generatorEnv.apiHost}/api/collection/detail/${fetchIndex}`, {
          params: {
            uid: materialId,
          }
        });
      })
    ).subscribe(v => {
      // v.images = null;
      // v['threeDFiles'] = [
      //   {
      //     "ext": "zip",
      //     "name": "5217f069-b813-4d8b-b6b4-b63ad09374a0",
      //     "original": "https://dcm.s3.hicloud.net.tw/new/3d/2020-11-09/557eb3ae-7d0c-44ba-a6fe-733b6633f71e/5217f069-b813-4d8b-b6b4-b63ad09374a0.zip",
      //     "transform": {
      //       "gltf": "https://dcm.s3.hicloud.net.tw/new/3d/2020-11-09/557eb3ae-7d0c-44ba-a6fe-733b6633f71e/1f0b058d-94ee-44d3-833d-952aae481777.gltf"
      //     },
      //     "represent": null,
      //     "description": null,
      //     "contributor": null
      //   },
      //   // {
      //   //   "ext": "zip",
      //   //   "name": "5217f069-b813-4d8b-b6b4-b63ad09374a0",
      //   //   "original": "https://dcm.s3.hicloud.net.tw/new/3d/2020-11-09/557eb3ae-7d0c-44ba-a6fe-733b6633f71e/5217f069-b813-4d8b-b6b4-b63ad09374a0.zip",
      //   //   "transform": {
      //   //     "gltf": "https://dcm.s3.hicloud.net.tw/new/3d/2020-11-09/557eb3ae-7d0c-44ba-a6fe-733b6633f71e/1f0b058d-94ee-44d3-833d-952aae481777.gltf"
      //   //   },
      //   //   "represent": null,
      //   //   "description": null,
      //   //   "contributor": null
      //   // }
      // ];
      // v.downloadImages = ['https://dcm.s3.hicloud.net.tw/new/f_upload/collection/2019-09-18/b36f074a-a819-43b8-aa58-0b9f9a528ac0/a751eb48-11c4-4091-b432-c2f7c1ed4aed.jpg'];
      // v.imageLic="僅限公開瀏覽"
      if (isNullOrUndefined(v)) {
        this.loggerService.error(`DetailComponent 取素材明細 API 回傳 null body`);
        if (!this.isBrowser) {
          this.response.status(500);
        } else {
          navigateCrossPlatform(this.serverConfigService.isBrowser, this.router, this.response, [`${this.toHomePath}/404`]);
        }
      }
      this.data = Object.assign({}, v);
      if (this.data['threeDFiles'] && this.data['threeDFiles']['length'] && !this.data.iframeUrl && !(this.data.images && this.data.images.length)) {
        this.isShow3DFiles = true;
      }
      const keys = Object.keys(this.data);
      keys.forEach(key => {
        const skipFiledNames = ['relevant', 'threeDFiles'];
        if (!this.COMMON_FIELD_KEYS.find(ck => ck === key) && !skipFiledNames.find(ck => ck === key)) {
          this.nonCommonFieldKeys.push(key);
        }
      });

      // for dev only
      // this.data.description = '本資料節錄自松山社區大學編輯團隊撰寫之《松山區志》，為紀錄松山區文史發展之地方誌，其中對於松山生活景象之保存與介紹，呈現其為臺北市商業化、國際化最早的區域之樣貌。';
      // this.data.contentLic = 'PDM';
      // this.data.downloadImages = [
      //   '/assets/images/v040/img-400-11.webp'
      // ];
      // this.data.imageLic = '僅限公開瀏覽';
      // this.data['contributors'] = [{role: '穀笠合作社', name: '張森葳負責人'}, {role: '社團法人南投縣埔里鎮籃城社區發展協會', name: '賴克祥理事'}];

      if (this.data.downloadImages && this.data.downloadImages.length && this.data.imageLic) {
        this.initCollectionOpenImages();
      }

      let desc: string;
      if (this.data.description) {
        const div = this.renderer.createElement('div') as HTMLElement;
        div.innerHTML = this.data.description;
        desc = div.textContent.slice(0, 150);
      } else { desc = ''; }

      // 設定 SEO Meta tag
      this.templateService.siteInfo$.pipe(take(1)).subscribe((siteInfo) => {
        this.templateService.setWebTitle({
          title: `${this.data.title}｜${siteInfo.metadata.title}`,
          desc,
          image: `${this.apiHost}/api/collection/image/${this.fetchIndexCode}?uid=${this.materialId}`
        });
      });
      if (!this.isBrowser) {
        // 設定 JSON LD
        this.schemaOrgData = this.genSchemaOrgData(this.data, desc);
      }
    });
    this._subc.push(subc);

    // 取素材留言
    if (!this.isBrowser) {
      this.loggerService.info(`DetailComponent 取素材留言`);
    }
    subc = combineLatest(
      this.refetchMessage$.pipe(startWith(1)),
      this.route.queryParams,
    ).pipe(
      map(([n, params]) => ({fetchIndex: params.indexCode, materialId: params.id})),
      switchMap(({fetchIndex, materialId}) => {
        this.fetchIndexCode = fetchIndex;
        if (!this.isBrowser) {
          this.loggerService.info(`DetailComponent 取素材留言 call API`);
        }
        return this.commonHttp.get<any[]>(`${this.generatorEnv.apiHost}/api/collection/detail/message/${fetchIndex}`, {
          params: {
            uid: materialId,
          }
        });
      })
    ).subscribe(v => {
      this.messages = v;
      this.messages.forEach((msg, i) => {
        const cloneColorSticks = this.COLOR_STICKS.slice();
        cloneColorSticks.sort(() => {
          return (0.5 - Math.random());
        });
        msg['headColor'] = cloneColorSticks[i % this.COLOR_STICKS.length];
      });
    });
    this._subc.push(subc);

    if (this.isBrowser) {
      // 幫已登入的使用者建立頭像
      subc = this.memberProxyService.getHasLoginSystem$().pipe(
        filter(ready => !!ready),
        switchMap(v => this.memberProxyService.getMemberInfo$()),
      ).subscribe(memberInfo => {
        this.memberInfo = memberInfo;
        if (memberInfo) {
          this.memberInfo['headColor'] = this.COLOR_STICKS[Math.ceil(Math.random() * this.COLOR_STICKS.length)];
        }
      });
      this._subc.push(subc);
    }
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      loadLazyCssFile(this.renderer, this.el.nativeElement, 'printContentStyle', '/assets/print-content.css');
    }
  }

  ngOnDestroy(): void {
    if (this.isBrowser) {
      const styleLink = this.document.body.querySelector('#printContentStyle') as any;
      this.document.body.removeChild(styleLink);
    }

    if (this._subc) {
      while (this._subc.length) {
        const subc = this._subc.shift();
        if (subc) {
          subc.unsubscribe();
        }
      }
    }
  }

  friendlyPrint(evt: UIEvent) {
    evt.preventDefault();
    window.print();
  }

  /** 留言 */
  leftComment(commentEl: HTMLTextAreaElement) {
    const comment: string = commentEl.value;

    if (!comment) { return; }
    if (this.isCommentUploading) { return; }
    if (!this.memberInfo) {
      this.globalComponentService.openInfoAlert('請先登入', {
        afterClose: () => {
          this.memberProxyService.login(MEMBER_LOGIN_WAY.CULTURE_CENTER);
        }
      });
      return;
    }

    this.isCommentUploading = true;
    this.userService.leftMessage(this.fetchIndexCode, this.materialId, this.memberInfo.name, comment).subscribe(v => {
      this.isCommentUploading = false;
      commentEl.value = null;
      this.refetchMessage$.next();
    });
  }

  /** 載入資料 */
  loadData(params: { limit: number; offset: number; sort: string; order: string; keyword: string; isFuzzyMode: boolean; query: string; }): Observable<ITRISearchResult> {
    if (params.keyword) {
      return this.dataSearchService.searchByITRI(params);
    } else {
      return this.dataSearchService.searchByMore(params);
    }
  }

  /** 初始化要帶進相片瀏覽器的資料 */
  initCollectionOpenImages() {
    this.openReuseGalleryImages = this.data.downloadImages.map((url, index) => {
      const ret: PhotoSwipeFigureSlide = {
        src: url,
        msrc: url,
        title: `${this.data.title}-代表圖像-第${index + 1}張`,
        desc: '',
        imageAuthority: licToAuthorityType(this.data.imageLic),
        imageAuthMan: this.data.sourceName,
        originUrl: this.sharePageUrl,
      };
      return ret;
    });
  }

  downloadRightsCitationFormatter = (downloadData: PhotoSwipeFigureSlideDownLoadData) => {
    if (downloadData) {
      const sb: string[] = [];
      switch (this.fetchIndexCode) {
        case 'Culture_Event':
          sb.push(this.data.title);
          if (this.data['contributors'] && Array.isArray(this.data['contributors'])) {
            const c_sb: string[] = [];
            this.data['contributors'].forEach(contributor => {
              if (contributor['role'] && contributor['name']) {
                c_sb.push(`${contributor['role']}-${contributor['name']}`);
              } else if (contributor['name']) {
                c_sb.push(contributor['name']);
              }
            });
            if (c_sb.length) {
              sb.push(`貢獻者：${c_sb.join('；')}`);
            }
          }
          if (this.data['openImageImageContributor']) {
            sb.push(`數位物件貢獻者：${this.data['openImageImageContributor']}`);
          }
          if (this.data.imageLic) {
            sb.push(`數位物件授權：${licToAuthorityShortDescription(this.data.imageLic)}`);
          }
          if (this.data['createDept']) {
            sb.push(`建檔單位：${this.data['createDept']}`);
          }
          return `${sb.join(' / ')} @ 國家文化記憶庫 ${ downloadData.originUrl }`;
        case 'Culture_Object':
        case 'Culture_Media':
          sb.push(this.data.title);
          if (this.data['creator']) {
            sb.push(`創作者：${this.data['creator']}`);
          }
          if (this.data['contributors'] && Array.isArray(this.data['contributors'])) {
            const c_sb: string[] = [];
            this.data['contributors'].forEach(contributor => {
              if (contributor['role'] && contributor['name']) {
                c_sb.push(`${contributor['role']}-${contributor['name']}`);
              } else if (contributor['name']) {
                c_sb.push(contributor['name']);
              }
            });
            sb.push(`貢獻者：${c_sb.join('；')}`);
          }
          if (this.data['openImageImageContributor']) {
            sb.push(`數位物件貢獻者：${this.data['openImageImageContributor']}`);
          }
          if (this.data.imageLic) {
            sb.push(`數位物件授權：${licToAuthorityShortDescription(this.data.imageLic)}`);
          }
          if (this.data['createDept']) {
            sb.push(`建檔單位：${this.data['createDept']}`);
          }
          return `${sb.join(' / ')} @ 國家文化記憶庫 ${ downloadData.originUrl }`;
        case 'Culture_People':
        case 'Culture_Place':
        case 'Culture_Organization':
        case 'Culture_Route':
        case 'Culture_Invisible':
          sb.push(this.data.title);
          if (this.data['openImageImageContributor']) {
            sb.push(`數位物件貢獻者：${this.data['openImageImageContributor']}`);
          }
          if (this.data.imageLic) {
            sb.push(`數位物件授權：${licToAuthorityShortDescription(this.data.imageLic)}`);
          }
          if (this.data['createDept']) {
            sb.push(`建檔單位：${this.data['createDept']}`);
          }
          return `${sb.join(' / ')} @ 國家文化記憶庫 ${ downloadData.originUrl }`;
        default:
          return `${ downloadData.title ? downloadData.title + ' / ' : '' }${ downloadData.imageAuthMan ? '授權人：' + downloadData.imageAuthMan + ' / ' : '' }${ downloadData.imageAuthorityText } @ 國家文化記憶庫 ${ downloadData.originUrl }。`
      }
    } else {
      return undefined;
    }
  };

  /** 開啟可下載圖片的相片瀏覽器 */
  openOpenedCollectionGallery(e: Event) {
    e.preventDefault();
    this.photoSwipeService.open('0', this.openReuseGalleryImages, this.openReuseGallery.nativeElement);
    this.gALoggerService.log({
      event: 'download_material',
      page_id: this.materialId,
      fetch_index: this.fetchIndexCode,
      download_type: 'image',
    });
  }

  /** 判斷資料是否為字串 */
  isString(value: any) {
    return typeof value === 'string';
  }

  /** 判斷文字是否為連結字串 */
  isLink(value: string) {
    return value.startsWith('http://') || value.startsWith('https://');
  }

  /** 判斷資料是否為物件 */
  isObject(value: any) {
    return typeof value === 'object';
  }

  /** 判斷物件是否為陣列物件 */
  isArray(value: object) {
    return Array.isArray(value);
  }

  /** 判斷陣列物件是否為字串陣列 */
  isStrArray(value: any[]) {
    const findNotStr = value.find(v => v && (typeof v !== 'string'));
    return !findNotStr;
  }

  getObjKeys(value: object) {
    return Object.keys(value);
  }

  stringlizeCategories(categories: any) {
    const arr = [];
    if (categories.category2) {
      arr.push(categories.category2);
    }
    if (categories.category3) {
      arr.push(categories.category3);
    }
    if (categories.category4) {
      arr.push(categories.category4);
    }
    return arr.join('-');
  }

  stringlizeContributors(v: any) {
    return (v as any[]).map(v2 => {
      if (v2.role && v2.name) {
        return `<span class="label">${v2.role}</span><div class="label-cont"><span>${v2.name}</span></div>`;
      }
      return '';
    }).filter(v2 => !!v2).join('<br>');
  }

  stringlizeDates(v: any) {
    return (v as any[]).map(v2 => {
      if (v2.type && v2.date) {
        return `<span class="label">${v2.type}</span><div class="label-cont"><span>${v2.date}</span>` + (v2.endDate ? ` ~ <span>${v2.endDate}</span>` : ``) + `</div>`;
      }
      return '';
    }).filter(v2 => !!v2).join('<br>');
  }

  stringlizePlaces(v: any) {
    return (v as any[]).map(v2 => {
      if (v2.city && v2.address) {
        return `${v2.city}${v2.address} (${v2.lng}, ${v2.lat})`;
      }
      return '';
    }).filter(v2 => !!v2).join('<br>');
  }

  toggleDownloadTip() {
    this.dwTooltip.toggle();
    this.gALoggerService.log({
      event: 'download_material',
      page_id: this.materialId,
      fetch_index: this.fetchIndexCode,
      download_type: 'text',
    });
  }

  closeDownloadTooltip = (toggler?: HTMLElement, container?: HTMLElement) => {
    this.dwTooltip.close();
  }

  listenOnDownloadTooltipOpen = (cb: () => void) => {
    this.dwTooltip.opened.subscribe(() => {
      cb();
    });
  }

  listenOnDownloadTooltipClose = (cb: () => void) => {
    this.dwTooltip.closed.subscribe(() => {
      cb();
    });
  }

  /**
   *
   * 判斷是object , 但卻是空object, 不顯示
   * 判斷是空字串, 或是一個空白字串, 不顯示
   */
   isShowNonCommonField(dataKey): boolean {
    if (!dataKey || dataKey === '' || dataKey === ' ') {
      return false;
    } else {
      if (this.isObject(dataKey) && this.getObjKeys(dataKey).length === 0) {
        return false;
      }

      return true;
    }
  }

  genSchemaOrgData(data: Detail, desc: string): any {
    const schemaOrgData = {
      '@context': 'http://schema.org',
      '@type': 'CreativeWork'
    };
    schemaOrgData['identifier'] = `${this.fetchIndexCode}-${this.materialId}`;
    schemaOrgData['url'] = this.serverConfigService.url;
    schemaOrgData['inLanguage'] = this.data['language'] || this.translateService.currentLang || 'zh-tw';
    if (data.images && data.images[0] && data.imageLic) {
      const auth = transformAuthLicense(data.imageLic);
      schemaOrgData['image'] = {
        '@type': 'ImageObject',
        contentUrl: `${this.apiHost}/api/collection/image/${this.fetchIndexCode}?uid=${this.materialId}`,
        license: `${this.toHomePath}/license`,
        acquireLicensePage: auth.url
      };
    }
    if (data.title) { schemaOrgData['name'] = data.title; }
    if (data.description) { schemaOrgData['description'] = desc; }
    if (data.linkPath) { schemaOrgData['sameAs'] = data.linkPath; }
    if (data.keywords) { schemaOrgData['keywords'] = data.keywords.join(','); }
    return schemaOrgData;
  }

  /** 當素材圖片載入完成後調用 */
  onMaterialImageSrcLoad(item: any, image: HTMLImageElement) {
    this.zone.run(() => {
      if (image) {
        item['imageNaturalWidth'] = image.naturalWidth;
        item['imageNaturalHeight'] = image.naturalHeight;
      }
    });
  }
  
  /** 圖片區塊改成顯示3D檔案 */
  toggle3DFiles() {
    this.isShow3DFiles = !this.isShow3DFiles;
  }

  /** 複製 input 元素內容到剪貼簿 - 支援 iOS */
  async copyToClipBoard(target: HTMLElement): Promise<boolean> {
    const inputEl = target as HTMLTextAreaElement;

    if (!inputEl || inputEl.tagName !== 'TEXTAREA') {
      console.error('copyToClipBoard，目標不是 textArea 元素');
      return false;
    }

    try {
      const text = inputEl.value;

      // 優先使用現代 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        // 確保 input 可以被選取
        inputEl.readOnly = false;
        inputEl.disabled = false;

        // 聚焦並選取所有內容
        inputEl.focus();
        inputEl.select();
        
        await navigator.clipboard.writeText(text);
        
        // 恢復原始狀態
        inputEl.readOnly = true;
        inputEl.blur(); // 移除焦點

        return true;
      }

      // Fallback 到選取 + execCommand 方式
      return this.selectAndCopy(inputEl);

    } catch (error) {
      console.error('Clipboard API 複製失敗，嘗試 fallback 方式', error);
      // 如果 Clipboard API 失敗，嘗試 fallback 方式
      return this.selectAndCopy(inputEl);
    }
  }

  /** 選取 input 內容並複製 */
  private selectAndCopy(inputEl: HTMLTextAreaElement): boolean {
    try {
      // 確保 input 可以被選取
      inputEl.readOnly = false;
      inputEl.disabled = false;

      // 聚焦並選取所有內容
      inputEl.focus();
      inputEl.select();

      // iOS 需要額外設置選取範圍
      if (this.isIOSDevice()) {
        inputEl.setSelectionRange(0, inputEl.value.length);
      }

      // 執行複製命令
      const successful = document.execCommand('copy');

      // 恢復原始狀態
      inputEl.readOnly = true;
      inputEl.blur(); // 移除焦點

      return successful;
    } catch (error) {
      console.error('selectAndCopy 選取複製失敗:', error);
      return false;
    }
  }

  /** 檢測是否為 iOS 設備 */
  private isIOSDevice(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  /** 顯示複製結果的輔助方法 */
  async handleCopyWithFeedback(target: HTMLElement) {
    const success = await this.copyToClipBoard(target);
    if (!success) {
      console.log('複製失敗，請手動選取複製');
    } else if (this.isIOSDevice()) {
      window.alert('已複製到剪貼簿');
    }
  }
}

/** 將權力駐記轉換成箱片瀏覽器吃的格式 */
export function licToAuthorityType(licName: string) {
  let type: number;
  switch (licName) {
    case 'PDM':
      type = 0;
      break;
    case 'CC0':
      type = 1;
      break;
    case 'OGDL':
      type = 2;
      break;
    case 'CC BY':
      type = 3;
      break;
    case 'CC BY-SA':
      type = 4;
      break;
    case 'CC BY-ND':
      type = 7;
      break;
    case 'CC BY-NC':
      type = 5;
      break;
    case 'CC BY-NC-SA':
      type = 6;
      break;
    case 'CC BY-NC-ND':
      type = 8;
      break;
    case '僅限公開瀏覽':
      type = 11;
      break;
  }

  return Object.assign(new Authority(), {
    type,
  });
}


export function licToAuthorityShortDescription(licName: string) {
  switch (licName) {
    case 'PDM':
      return 'PDM'
    case 'CC0':
      return 'CC0'
    case 'OGDL':
      return 'OGDL 1.0'
    case 'CC BY':
      return 'CC BY 3.0 TW +'
    case 'CC BY-SA':
      return 'CC BY-SA 3.0 TW +'
    case 'CC BY-ND':
      return 'CC BY-ND 3.0 TW +'
    case 'CC BY-NC':
      return 'CC BY-NC 3.0 TW +'
    case 'CC BY-NC-SA':
      return 'CC BY-NC-SA 3.0 TW +'
    case 'CC BY-NC-ND':
      return 'CC BY-NC-ND 3.0 TW +'
    case '僅限公開瀏覽':
      return '受著作權法保護-僅限於本平台有限度公開瀏覽'
    default:
      return '授權不明';
  }
}